import { createI18n } from 'vue-i18n';

const locale = window._locale || 'en';

function unflatten(flat) {
  const nested = {};

  for (const key of Object.keys(flat || {})) {
    const parts = key.split('.');
    let node = nested;

    parts.forEach((part, i) => {
      if (i === parts.length - 1) {
        node[part] = flat[key];
      } else {
        node[part] = node[part] || {};
        node = node[part];
      }
    });
  }

  return nested;
}

export default createI18n({
  warnHtmlMessage : false,
  legacy: false,
  locale,
  messages: {
    [locale]: unflatten(window.translations)
  }
});
